import api from "./api";

export const uploadMedia = async (file, refId = null, ref = null, field = null) => {
  try {
    const formData = new FormData();
    formData.append('files', file);
    
    // Add optional reference parameters if provided
    if (refId) formData.append('refId', refId);
    if (ref) formData.append('ref', ref);
    if (field) formData.append('field', field);

    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data[0]; // Strapi returns an array, we take the first item
  } catch (error) {
    console.error('Error uploading file:', error);
    throw new Error(error.response?.data?.error?.message || 'Error uploading file');
  }
};

export const deleteMedia = async (imageId) => {
  try {
    if (!imageId) {
      throw new Error('Image ID is required');
    }

    await api.delete(`/upload/files/${imageId}`);
    return true;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw new Error(error.response?.data?.error?.message || 'Error deleting file');
  }
};

export const replaceMedia = async (oldImageId, newFile, refId = null, ref = null, field = null) => {
  try {
    // Delete old image if it exists
    if (oldImageId) {
      await deleteMedia(oldImageId);
    }

    // Upload new image
    const newImage = await uploadMedia(newFile, refId, ref, field);
    return newImage;
  } catch (error) {
    console.error('Error replacing file:', error);
    throw new Error(error.response?.data?.error?.message || 'Error replacing file');
  }
};

export const uploadMultipleMedia = async (files, refId = null, ref = null, field = null) => {
  try {
    const formData = new FormData();
    
    // Append each file to the FormData
    files.forEach((file) => {
      formData.append('files', file);
    });
    
    // Add optional reference parameters if provided
    if (refId) formData.append('refId', refId);
    if (ref) formData.append('ref', ref);
    if (field) formData.append('field', field);

    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading multiple files:', error);
    throw new Error(error.response?.data?.error?.message || 'Error uploading files');
  }
};